export default __webpack_public_path__ + "static/media/redcross.6ed18440.svg";